import $ from "jquery";
import L from "leaflet";

import 'leaflet/dist/leaflet.css';
import './../../scss/theme/components/room-map.scss';

// Coords from openStreetMap https://www.openstreetmap.org/directions#map=19/51.70647/8.77033
// https://www.uni-paderborn.de/fileadmin/presse-kommunikation-marketing/Campus_Lageplan_2022/Grafik-Lageplan2022.png
var address2coords = {
    'Warburger Str. 100' : [51.70825, 8.77209],
    'Fürstenallee 11' : [51.73200, 8.73491],
    'Zukunftsmeile 1' : [51.73043, 8.73784],
    'Zukunftsmeile 2' : [51.73020, 8.74003],
    'Technologiepark 6' : [51.70088, 8.76044],
    'Technologiepark 8' : [51.70080, 8.76173],
    'Technologiepark 9' : [51.70099, 8.76256],
    'Technologiepark 11' : [51.70084, 8.76415],
    'Technologiepark 12' : [51.70106, 8.76360],
    'Technologiepark 21' : [51.70088, 8.76500],
    'Haxterhöhe 2' : [51.70031, 8.77682],
    'Harsewinkelweg 4' : [51.70440, 8.77409], //SP1
    'Warburger Str. 132' : [51.70462, 8.77826], //SP2
    'Neustadt 22' : [51.93043, 8.87618], //HfM Detmold
    'Mersinweg 2a' : [51.70632, 8.76812], //Studentenwerk
};
var building2coords = {
    'A' : [51.70771, 8.77115],
    'AM' : [51.70699, 8.77179],
    'Audimax' : [51.70699, 8.77179],
    'B' : [51.70827, 8.77275],
    'BI' : [51.70826, 8.77276],
    'C' : [51.70804, 8.77212],
    'D' : [51.70756, 8.77195],
    'DW/IBFM' : [51.70499, 8.77147],
    'DW' : [51.70499, 8.77147],
    'E' : [51.70703, 8.77123],
    'F' : [51.73179, 8.73465], // F mit Etagen U, 1, 2
    'G' : [51.70807, 8.77054],
    'Golf' : [51.70031, 8.77682], // Dummy for reactive move to Golfakademie
    'Golfakademie' : [51.70031, 8.77682],
    'GOLFAKADEMIE' : [51.70031, 8.77682],
    'GTZ' : [51.70421, 8.77490],
    'H' : [51.70870, 8.77228],
    'HF' : [51.93067, 8.88126], // Dummy for reactive move to HFM1
    'HFM' : [51.93067, 8.88126], // Dummy for reactive move to HFM1
    'HFM1' : [51.93067, 8.88126],
    'HFM2' : [51.92867, 8.88183],
    'HFM3' : [51.93141, 8.88189],
    'HFM4' : [51.93043, 8.87618], // Palaisgarten mit Konzerthaus, etc.
    'I' : [51.70863, 8.77366],
    'IBFM' : [51.70499, 8.77147],
    'IBZ' : [51.70978, 8.77250],
    'IW' : [51.70752, 8.77041],
    'J' : [51.70793, 8.77308],
    'K' : [51.70743, 8.77273],
    'L' : [51.70611, 8.77057],
    'M' : [51.70871, 8.77159],
    'ME' : [51.70871, 8.77159],
    'N' : [51.70652, 8.77055],
    'NW' : [51.70742, 8.77361],
    'NWL' : [51.70753, 8.77422],
    'O' : [51.70731, 8.76937],
    'P' : [51.70917, 8.76894],
    'P1' : [51.70906, 8.76887],
    'P2' : [51.70842, 8.77059],
    'P3' : [51.70869, 8.76998],
    'P4' : [51.70833, 8.76942],
    'P5' : [51.70866, 8.76868],
    'P6' : [51.70882, 8.76833],
    'P7' : [51.70904, 8.76802],
    'P8' : [51.70941, 8.76782],
    'P9' : [51.71038, 8.76814],
    'P10' : [51.71008, 8.76834],
    'Q' : [51.70925, 8.77318],
    'S' : [51.71003, 8.77354],
    'SI' : [51.71003, 8.77354],
    'Silo' : [51.71003, 8.77354],
    'SP' : [51.70450, 8.77434],
    'SP1' : [51.70450, 8.77434],
    'SP2' : [51.70458, 8.77775],
    'SP 1' : [51.70450, 8.77434],
    'SP 2' : [51.70458, 8.77775],
    'ST' : [51.70929, 8.77112],
    'STW' : [51.70649, 8.76801],
    'TVZ' : [51.70812, 8.77532],
    'V' : [51.70966, 8.77205],
    'W' : [51.70608, 8.76906],
    'X' : [51.70595, 8.76839],
    'Y' : [51.70553, 8.76716],
    'ZD' : [51.70914, 8.77219],
    'T' : [51.70088, 8.76044], // Dummy for reactive move to TP6
    'TP' : [51.70088, 8.76044], // Dummy for reactive move to TP6
    'TP6' : [51.70088, 8.76044],
    'TP8' : [51.70080, 8.76173],
    'TP9' : [51.70099, 8.76256],
    'TP11' : [51.70084, 8.76415],
    'TP12' : [51.70106, 8.76360],
    'TP21' : [51.70088, 8.76500],
    'ZSL' : [51.70786, 8.77413],
    'ZM1' : [51.73043, 8.73784],
    'ZM 1' : [51.73043, 8.73784],
    'ZM2' : [51.73020, 8.74003],
    'ZM 2' : [51.73020, 8.74003],
};
var names2coords = {
    'HNI' : [51.73134, 8.73565],
    'BIB' : [51.73096, 8.73660],
    'SICP' : [51.73184, 8.73487],
    'Frauenhofer EIM' : [51.73045, 8.73784],
    'Stadtcampus' : [51.71708, 8.74847],
    'Hochschule für Musik Detmold' : [51.93067, 8.88126],
    'Palaisgarten' : [51.93043, 8.87618],
    'Bibliothek' : [51.70827, 8.77275],
    'Cafete' : [51.70843, 8.77167],
    'Grill' : [51.70845, 8.77150],
    'Bona Vista' : [51.70862, 8.77183],
    'Mensa Academica' : [51.70857, 8.77152],
    'Mensa Forum' : [51.70885, 8.77111],
    'Mensula' : [51.70886, 8.77147],
    'AStA' : [51.70848, 8.77130],
    'AStA Copyservice' : [51.70856, 8.77127],
    'Uni Zwerge' : [51.71006, 8.76761],
    'Jenny-Aloni-Haus' : [51.70978, 8.77250],
    'Studiobühne' : [51.70789, 8.77129],
    'PLAZ' : [51.70618, 8.76894],
    'ZSB' : [51.70601, 8.76906],
    'IMT Service' : [51.70863, 8.77343],
    'IMT' : [51.70649, 8.77050],
    'Kita' : [51.70675, 8.77114],
    'Kita 1' : [51.70527, 8.77407],
    'Kita 2' : [51.71007, 8.76761],
    'PUki' : [51.70675, 8.77114],
    'Mensa' : [51.70871, 8.77159],
    'PhoQs-Lab' : [51.71008, 8.76834],
    'Akzelerator' : [51.71975, 8.77942],
    'TecUP' : [51.70080, 8.76173],
    'Garage33' : [51.70080, 8.76173],
    'Kunstrasenplatz' : [51.70474, 8.77582],
    'Rasenplatz' : [51.70336, 8.77558],
    'Sportgelände' : [51.70336, 8.77558],
    'Wohnheim Vogeliusweg' : [51.70583, 8.77465],
    'Wohnheim Peter-Hille-Weg' : [51.71069, 8.76927],
    'Wohnheim Alois-Fuchs-Weg' : [51.70214, 8.75683],
    'Campus Lounge' : [51.70661, 8.76785],
    'Boarding House' : [51.70661, 8.76785],
};

// Default is 'Warburger Str. 100', others are listet here
var building2street = {
    'DW/IBFM' : 'Pohlweg 85',
    'DW' : 'Pohlweg 85',
    'IBFM' : 'Pohlweg 85',

    'F' : 'Fürstenallee 11', // F mit Etagen U, 1, 2
    'ZM1' : 'Zukunftsmeile 1',
    'ZM 1' : 'Zukunftsmeile 1',
    'ZM2' : 'Zukunftsmeile 2',
    'ZM 2' : 'Zukunftsmeile 2',

    'Golf' : 'Haxterhöhe 2', // Dummy for reactive move to Golfakademie
    'Golfakademie' : 'Haxterhöhe 2',
    'GOLFAKADEMIE' : 'Haxterhöhe 2',

    'GTZ' : 'Harsewinkelweg 4',
    'SP' : 'Harsewinkelweg 4',
    'SP1' : 'Harsewinkelweg 4',
    'SP 1' : 'Harsewinkelweg 4',

    'SP2' : 'Warburger Str. 132',
    'SP 2' : 'Warburger Str. 132',

    'HF' : 'Hornsche Str. 39', // Dummy for reactive move to HFM1
    'HFM' : 'Hornsche Str. 39', // Dummy for reactive move to HFM1
    'HFM1' : 'Hornsche Str. 39',
    'HFM2' : 'Willi-Hofmann-Str. 5',
    'HFM3' : 'Hornsche Str. 44',
    'HFM4' : 'Neustadt 22', // Palaisgarten, etc.

    'STW' : 'Mersinweg 2a',

    'T' : 'Technologiepark 6', // Dummy for reactive move to TP6
    'TP' : 'Technologiepark 6', // Dummy for reactive move to TP6
    'TP6' : 'Technologiepark 6',
    'TP8' : 'Technologiepark 8',
    'TP9' : 'Technologiepark 9',
    'TP11' : 'Technologiepark 11',
    'TP12' :  'Technologiepark 12',
    'TP21' : 'Technologiepark 21',
};

// Default is '33098 Paderborn', others are listet here
var building2city = {
    'DW/IBFM' : '33100 Paderborn',
    'DW' : '33100 Paderborn',
    'IBFM' : '33100 Paderborn',

    'F' : '33102 Paderborn', // F mit Etagen U, 1, 2
    'ZM1' : '33102 Paderborn',
    'ZM 1' : '33102 Paderborn',
    'ZM2' : '33102 Paderborn',
    'ZM 2' : '33102 Paderborn',

    'Golf' : '33100 Paderborn', // Dummy for reactive move to Golfakademie
    'Golfakademie' : '33100 Paderborn',
    'GOLFAKADEMIE' : '33100 Paderborn',

    'GTZ' : '33100 Paderborn',
    'SP' : '33100 Paderborn',
    'SP1' : '33100 Paderborn',
    'SP 1' : '33100 Paderborn',

    'SP2' : '33100 Paderborn',
    'SP 2' : '33100 Paderborn',

    'HF' : '32756 Detmold', // Dummy for reactive move to HFM1
    'HFM' : '32756 Detmold', // Dummy for reactive move to HFM1
    'HFM1' : '32756 Detmold',
    'HFM2' : '32756 Detmold',
    'HFM3' : '32756 Detmold',
    'HFM4' : '32756 Detmold',

    'STW' : '33100 Paderborn',

    'T' : '33100 Paderborn',  // Dummy for reactive move to TP6
    'TP' : '33100 Paderborn', // Dummy for reactive move to TP6
    'TP6' : '33100 Paderborn',
    'TP8' : '33100 Paderborn',
    'TP9' : '33100 Paderborn',
    'TP11' : '33100 Paderborn',
    'TP12' :  '33100 Paderborn',
    'TP21' : '33100 Paderborn',
};

// translations
var voc = {
    'open': {
        "de":"Navigation öffnen",
        "en":"Open navigation"
    },
    'with': {
        "de":"Mit",
        "en":"With"
    },
    'room': {
        "de":"Raum",
        "en":"Room"
    },
    'building': {
        "de":"Gebäude",
        "en":"Building"
    },
    'address': {
        "de":"Adresse",
        "en":"Address"
    }
};

function getTranslation(key, lang){
    return voc[key][lang];
}

var defaultZoom = 18;
var defaultCoords = ['51.70825', '8.77209'];
var maps = {};
var osmCopyright = '&copy; <a href="http://openstreetmap.org/copyright">OpenStreetMap</a>';

function renderMaps(container, force = false){

    $(container).find('.map').each(function(ele){
        var id = $(this).attr('id');
        var lang = $(this).data('lang');
        if( ! lang){
            lang = 'en';
        }

        if(maps[id]){
            if(force){
                maps[id].off();
                maps[id].remove();
            }else{
                return;
            }
        }

        maps[id] = L.map(id, {
            scrollWheelZoom: false, // disable original zoom function
            smoothWheelZoom: true,  // enable smooth zoom
            smoothSensitivity: 1,   // zoom speed. default is 1
            zoomControl: true,
            maxZoom: 18,
            minZoom: 12, //14
			maxBounds: new L.LatLngBounds(new L.LatLng(51.98, 8.67), new L.LatLng(51.65, 8.94)),
			//maxBoundsViscosity: 0.75
        }).setView([defaultCoords[0], defaultCoords[1]], 17);

        // Add the downloaded tiles
        // '/typo3conf/ext/upb_osm/Resources/Public/OsmTiles/{z}/{x}/{y}.png'
        // '/typo3conf/ext/upb_base/Resources/Public/OsmTiles/{z}/{x}/{y}.png'
        L.tileLayer('/typo3conf/ext/upb_osm/Resources/Public/OsmTiles/{z}/{x}/{y}.png', {
            attribution: osmCopyright,
            // maxZoom: 18,
            // minZoom: 0,
        }).addTo( maps[id] );

        function renderFooter(that, markerCoords){
            if($(that).find('a#open-map-'+id).length <= 0){
                if( ! markerCoords){
                    markerCoords = [defaultCoords[0], defaultCoords[1]];
                }

                $(that).append('<p class="d-none d-lg-block mb-0">'+getTranslation('open', lang) + ': </p><ul id="open-navigation" class="d-none d-lg-block mb-0"></ul>');
                var navigationList =  $(that).find('ul#open-navigation');
                //$(navigationList).append('<li><a id="open-map-'+id+'" target="_blank" rel="noreferrer noopener" href="https://www.openstreetmap.org/directions?from=&to='+markerCoords[0]+'%2C'+markerCoords[1]+'#map='+defaultZoom+'/'+markerCoords[0]+'/'+markerCoords[1]+'">'+getTranslation('with', lang) + ' OpenStreetMap (openstreetmap.org)</a></li>');
                $(navigationList).append('<li><a id="open-map-'+id+'" target="_blank" rel="noreferrer noopener" href="https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=%3B'+markerCoords[0]+'%2C'+markerCoords[1]+'#map='+defaultZoom+'/'+markerCoords[0]+'/'+markerCoords[1]+'">'+getTranslation('with', lang) + ' OpenStreetMap (openstreetmap.org)</a></li>');
                $(navigationList).append('<li><a id="open-map-'+id+'" target="_blank" rel="noreferrer noopener" href="https://www.google.com/maps/dir//'+markerCoords[0]+','+markerCoords[1]+'/@'+markerCoords[0]+','+markerCoords[1]+',17.24z?entry=ttu">'+getTranslation('with', lang) + ' GoogleMaps (maps.google.com)</a></li>');
                $(that).append('<p class="d-block d-lg-none mb-0"><a id="navigate-map-'+id+'" target="_blank" rel="noreferrer noopener" href="geo:'+markerCoords[0]+','+markerCoords[1]+'" target="_blank">Navigation öffnen</a></p>');
            }
        }

        // Render marker and footer
        const markerCoords = setViewAndMarker(maps[id], $(this), lang);
        renderFooter($(this).parent(), markerCoords);

        // var onChangeSelector = $(this).data('onchangeselector');
        // if(onChangeSelector){
        //     var that = $(this);
        //     $(onChangeSelector).on('input', function() {
        //         $(that).data('building', $(this).val());
        //         // Rerender marker and footer on changes
        //         const markerCoords = setViewAndMarker(maps[id], $(that));
        //         renderFooter(that, markerCoords);
        //     });
        // }
    });

};

// return coords of the marker
function setViewAndMarker(map, ele, lang){
    if($(ele).data('marker')){
        map.removeLayer($(ele).data('marker'));
    }

    var department = $(ele).data('area');
    var address = $(ele).data('address');
    var building_or_room = $(ele).data('building').toUpperCase();
    var isRoom = false;
    var setView = false;

    var building;
    var buildingIdentifier = building;
    if(building_or_room.indexOf(".") > 0){
        building = building_or_room.substring(0, building_or_room.indexOf("."));
        isRoom = true;
    }else if(building_or_room.indexOf(" ") > 0){
        building = building_or_room.substring(0, building_or_room.indexOf(" "));
    }else{
        building = building_or_room;
    }
    if(building){
        for (let i = building.length; i > 0; i--) {
            if(building2coords.hasOwnProperty(building.substring(0, i))){
                buildingIdentifier = building.substring(0, i);
                setView = building2coords[buildingIdentifier];
                break;
            }
        }
    }

    if(!address){
        if(setView && building2street.hasOwnProperty(buildingIdentifier)){
            address = building2street[buildingIdentifier] + ', ' + building2city[buildingIdentifier];
        }else{
            address = 'Warburger Str. 100, 33098 Paderborn'; // Fallback
        }
    }
    var street = address.split(", ")[0];
    var city = address.split(", ")[1];

    if(!setView){
        if(! address2coords.hasOwnProperty(street)){
            street = 'Warburger Str. 100';
            city = '33098 Paderborn';
        }
        setView = address2coords[street];
    }

    map.setView(setView, defaultZoom);
    var marker = L.marker(setView).addTo(map);
    if(building){
        if(department){
            marker.bindPopup("<b>"+department+"</b><br>"+street+"<br>"+city+"<br>"+getTranslation(isRoom ? 'room' : 'building', lang)+" "+building_or_room);
        }else{
            marker.bindPopup("<b>"+getTranslation(isRoom ? 'room' : 'building', lang)+" "+building_or_room+"</b><br>"+street+"<br>"+city);
        }
    }else{
        marker.bindPopup("<b>"+department+"</b><br>"+street+"<br>"+city);
    }
    var open = $(ele).data('open-marker');
    if(open){
        marker.openPopup();
    }
    $(ele).data('marker', marker);

    return setView;
}

window.addEventListener('DOMContentLoaded', () => {
    renderMaps('body');
    
    const mapModals = [...document.querySelectorAll('.map-modal.modal')].map((modalContainer) => {
        let that = modalContainer;
        modalContainer.addEventListener('shown.bs.modal', function(){
            renderMaps(that, true);
        })
    });

    // $('.map-modal.modal').on('show.bs.modal', function(){
    //     console.log('open');
    //     renderMaps();
    // });
});


// Open for navigation
// https://osm.org/go/0GlK5KXRq?m=
// https://www.openstreetmap.org/?mlat=51.70781&mlon=8.77140#map=19/51.70781/8.77140 Mit marker
// https://www.openstreetmap.org/#map=19/51.70781/8.77140

// https://www.openstreetmap.org/#map=19/51.70781/8.77140
// https://www.openstreetmap.org/#map=19/51.70781/8.77140


/* <iframe width="425" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=8.769160509109499%2C51.70708216910666%2C8.77363979816437%2C51.70853483578559&amp;layer=mapnik" style="border: 1px solid black"></iframe><br/><small>
    <a href="https://www.openstreetmap.org/#map=19/51.70781/8.77140">Größere Karte anzeigen</a>
</small> */
